import { render, staticRenderFns } from "./EmpMgmt.vue?vue&type=template&id=e0a64db6&"
import script from "./EmpMgmt.vue?vue&type=script&lang=js&"
export * from "./EmpMgmt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports